import React, { useEffect, useState } from "react"
import { Box, useTheme, useMediaQuery } from "@material-ui/core"
import TaskCreator from "./TaskCreator"
import ProcessCreator from "./ProcessCreator"
import AdhocCreator from "./AdhocCreator"
import { CreatorMaster } from "../Creators"

const JobCreator = ({ open, onClose, edit }) => {
  const theme = useTheme()
  const isInline = useMediaQuery(theme.breakpoints.down("xs"))
  const [subject, setSubject] = useState(null)

  const isOpen = Boolean(open)

  const isEdit = edit != null

  const handleOnClose = (event, isCancel) => {
    onClose(isCancel)
  }

  useEffect(() => {
    if (isOpen) {
      if (isEdit) setSubject("Edit job")
      else if (!isEdit && open !== "adhoc") setSubject(`Create ${open}`)
      else if (!isEdit && open === "adhoc") setSubject("Run ad hoc process")
    }
  }, [isOpen, isEdit, open])

  const form = (
    <>
      <Box mt={0}>
        {open === "task" && <TaskCreator onClose={handleOnClose} edit={edit} />}
        {open === "process" && <ProcessCreator onClose={handleOnClose} edit={edit} />}
        {open === "adhoc" && <AdhocCreator onClose={handleOnClose} />}
      </Box>
    </>
  )

  return (
    <CreatorMaster
      id="jobcreator-dialog"
      open={isOpen}
      title={subject}
      form={form}
      isEdit={isEdit}
      isInline={isInline}
      onClose={handleOnClose}
    />
  )
}

export { JobCreator }
